/**
 * @generated SignedSource<<181858799469dd3a77d7e7e53a6175e4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GoalUpdatesAsideViewQuery$variables = {
  completedGoalsTqlQuery: string;
  newGoalsTqlQuery: string;
  ownGoalsTqlQuery: string;
  workspaceUUID: string;
};
export type GoalUpdatesAsideViewQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"GoalUpdatesSideColumn">;
};
export type GoalUpdatesAsideViewQuery = {
  response: GoalUpdatesAsideViewQuery$data;
  variables: GoalUpdatesAsideViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "completedGoalsTqlQuery"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "newGoalsTqlQuery"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ownGoalsTqlQuery"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceUUID"
},
v4 = {
  "kind": "Variable",
  "name": "workspaceUuid",
  "variableName": "workspaceUUID"
},
v5 = {
  "kind": "Literal",
  "name": "first",
  "value": 20
},
v6 = {
  "kind": "ScalarField",
  "name": "count"
},
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = {
  "kind": "ScalarField",
  "name": "key"
},
v9 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v10 = {
  "concreteType": "GoalIcon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    {
      "kind": "ScalarField",
      "name": "appearance"
    }
  ]
},
v11 = {
  "kind": "ScalarField",
  "name": "name"
},
v12 = {
  "kind": "Literal",
  "name": "sorts",
  "value": [
    "CREATION_DATE_DESC"
  ]
},
v13 = [
  (v6/*: any*/),
  {
    "concreteType": "GoalEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "Goal",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "owner",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "aaid"
              },
              {
                "concreteType": "UserPII",
                "kind": "LinkedField",
                "name": "pii",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "picture"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "accountId"
                  }
                ]
              },
              (v7/*: any*/)
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "GoalUpdatesAsideViewQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "completedGoalsTqlQuery",
            "variableName": "completedGoalsTqlQuery"
          },
          {
            "kind": "Variable",
            "name": "newGoalsTqlQuery",
            "variableName": "newGoalsTqlQuery"
          },
          {
            "kind": "Variable",
            "name": "ownGoalsTqlQuery",
            "variableName": "ownGoalsTqlQuery"
          },
          (v4/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "GoalUpdatesSideColumn"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "GoalUpdatesAsideViewQuery",
    "selections": [
      {
        "alias": "ownGoals",
        "args": [
          (v5/*: any*/),
          {
            "kind": "Variable",
            "name": "q",
            "variableName": "ownGoalsTqlQuery"
          },
          {
            "kind": "Literal",
            "name": "sorts",
            "value": [
              "NAME_ASC"
            ]
          },
          (v4/*: any*/)
        ],
        "concreteType": "GoalConnection",
        "kind": "LinkedField",
        "name": "goalTql",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "concreteType": "GoalEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "Goal",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  {
                    "concreteType": "UserConnection",
                    "kind": "LinkedField",
                    "name": "watchers",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "alias": "newGoals",
        "args": [
          (v5/*: any*/),
          {
            "kind": "Variable",
            "name": "q",
            "variableName": "newGoalsTqlQuery"
          },
          (v12/*: any*/),
          (v4/*: any*/)
        ],
        "concreteType": "GoalConnection",
        "kind": "LinkedField",
        "name": "goalTql",
        "plural": false,
        "selections": (v13/*: any*/)
      },
      {
        "alias": "completedGoals",
        "args": [
          (v5/*: any*/),
          {
            "kind": "Variable",
            "name": "q",
            "variableName": "completedGoalsTqlQuery"
          },
          (v12/*: any*/),
          (v4/*: any*/)
        ],
        "concreteType": "GoalConnection",
        "kind": "LinkedField",
        "name": "goalTql",
        "plural": false,
        "selections": (v13/*: any*/)
      }
    ]
  },
  "params": {
    "cacheID": "483d0ad87a2dc8945e2818b8e226d272",
    "id": null,
    "metadata": {},
    "name": "GoalUpdatesAsideViewQuery",
    "operationKind": "query",
    "text": "query GoalUpdatesAsideViewQuery(\n  $workspaceUUID: UUID!\n  $ownGoalsTqlQuery: String!\n  $newGoalsTqlQuery: String!\n  $completedGoalsTqlQuery: String!\n) {\n  ...GoalUpdatesSideColumn_YUpuN\n}\n\nfragment GoalFollowersButton on Goal {\n  key\n  watchers {\n    count\n  }\n}\n\nfragment GoalName on Goal {\n  uuid\n  id\n  key\n  ...PlatformGoalIcon\n  name\n}\n\nfragment GoalRowWithFollowers on Goal {\n  key\n  ...GoalName\n  ...GoalFollowersButton\n}\n\nfragment GoalRowWithOwner on Goal {\n  key\n  ...GoalName\n  owner {\n    ...UserAvatar_2aqwkz\n    id\n  }\n}\n\nfragment GoalUpdatesSideColumn_YUpuN on Query {\n  ownGoals: goalTql(first: 20, workspaceUuid: $workspaceUUID, q: $ownGoalsTqlQuery, sorts: [NAME_ASC]) {\n    ...GoalWithFollowersSidebarSection\n  }\n  newGoals: goalTql(first: 20, workspaceUuid: $workspaceUUID, q: $newGoalsTqlQuery, sorts: [CREATION_DATE_DESC]) {\n    ...GoalWithOwnerSidebarSection\n  }\n  completedGoals: goalTql(first: 20, workspaceUuid: $workspaceUUID, q: $completedGoalsTqlQuery, sorts: [CREATION_DATE_DESC]) {\n    ...GoalWithOwnerSidebarSection\n  }\n}\n\nfragment GoalWithFollowersSidebarSection on GoalConnection {\n  count\n  edges {\n    node {\n      id\n      ...GoalRowWithFollowers\n    }\n  }\n}\n\nfragment GoalWithOwnerSidebarSection on GoalConnection {\n  count\n  edges {\n    node {\n      id\n      ...GoalRowWithOwner\n    }\n  }\n}\n\nfragment PlatformGoalIcon on Goal {\n  icon {\n    key\n    appearance\n  }\n}\n\nfragment UserAvatar_2aqwkz on User {\n  aaid\n  pii {\n    picture\n    accountId\n  }\n}\n"
  }
};
})();

(node as any).hash = "83785b4d3277e749d2fd42b97a4c8f1b";

export default node;
